import { onError } from '@apollo/client/link/error'
import { logoutCurrentUser } from '../../common/user/userActions'

// This also exists as an enum in the Parse SDK, but we don't want to import parse in this repo if avoidable as we're migrating away from it.
const PARSE_INVALID_SESSION_TOKEN_CODE = 209

export const invalidSessionLink = onError(({ networkError }) => {
  if (networkError?.result?.code === PARSE_INVALID_SESSION_TOKEN_CODE) {
    logoutCurrentUser().finally(() => window.location.reload())
  }
})
